<template>
    <score-template>
        <v-container grid-list-md text-xs-center>
            <v-layout row wrap justify-center>
                <v-flex xs6 sm6 md6>
                    <ptk-teampoint @reseted="resetTeamA" @added="addTeamA" @reduced="subTeamA"></ptk-teampoint>
                </v-flex>
                
                 <v-flex xs6 sm8 md5>
                    <ptk-teampoint @reseted="resetTeamB" @added="addTeamB" @reduced="subTeamB" bTeam="true"></ptk-teampoint>
                </v-flex>
            </v-layout>
        </v-container>
        <v-container grid-list-md text-xs-center>
            <v-layout row wrap>
                <v-flex xs12>
                    <ptk-attack-time></ptk-attack-time>
                </v-flex>
            </v-layout>
        </v-container>
        <v-container grid-list-md text-xs-center>
            <v-layout row wrap>
                <v-flex xs12>
                    <ptk-stopwatch></ptk-stopwatch>
                </v-flex>
            </v-layout>
        </v-container>
    </score-template>
</template>

<script>
import ScoreTemplate from '@/components/pages/templates/ScoreTemplate'
import PtkAttackTime from '@/components/ptkAttackTime'
import PtkStopwatch from '@/components/PtkStopWatch'
import PtkTeampoint from '@/components/PtkTeamPoint'

export default {
    name: 'ScorePage',
    components: {
        ScoreTemplate, PtkAttackTime, PtkStopwatch, PtkTeampoint
    },
    data: () => ({
        teamApoints: 0,
        teamBpoints: 0,
        mutted: false
    }),
    methods:{
        resetTeamA(){
            this.teamApoints = 0
            console.log('time A resetado')
        },
        resetTeamB(){
            this.teamBpoints = 0
            console.log('time B resetado')
        },
        addTeamA(){
            this.teamApoints++
            this.play()
        },
        addTeamB(){
            this.teamBpoints++
            this.play()
        },
        subTeamA(){
            this.teamApoints--
            this.play()
        },
        subTeamB(){
            this.teamBpoints--
            this.play()
        },
        play(){
            let sound = ""
            if(this.teamApoints > this.teamBpoints){
                sound = this.teamApoints + "a" + this.teamBpoints + ".mp3"
            }
            if(this.teamApoints < this.teamBpoints){
                sound = this.teamBpoints + "a" + this.teamApoints + ".mp3"
            }
            if(this.teamApoints == this.teamBpoints){
                sound = this.teamApoints + "a" + this.teamBpoints + ".mp3"
            }
            if(!this.mutted){
                var audio = new Audio("/static/sounds/teampoint/" + sound);
                audio.play();
            }
            console.log(sound)
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/ScorePage.vue